import { EditorMention, MentionSuggestion } from "../../mentions";

import { Component } from "react";
import MentionTypes from "./MentionTypes";
import PropTypes from "prop-types";
import { disruptors } from "./algoliaIndexes";

export default class DisruptorsProvider extends Component {
  static propTypes = {
    query: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { query } = this.props;
    this.emitSuggestions(query);
  }

  shouldComponentUpdate = nextProps => this.props.query !== nextProps.query;

  componentDidUpdate() {
    const { query } = this.props;
    this.emitSuggestions(query);
  }

  emitSuggestions = query => {
    const { onChange } = this.props;

    if (!query) {
      onChange([]);
      return;
    }

    disruptors.search(query, (err, content) => {
      if (err) {
        return;
      }

      const nextSuggestions = content.hits.filter(disruptor => disruptor.user.fullName).map(disruptor => {
        const { user } = disruptor;

        return MentionSuggestion.wrap(
          EditorMention.create(MentionTypes.DISRUPTOR, user.fullName, {
            _id: user._id,
            slug: user.slug,
            email: user.email,
          }),
          disruptor,
        );
      });

      onChange(nextSuggestions);
    });
  };

  render = () => null;
}
